import { useT } from "src/internationalization";

import { PrintableConfigError } from "./printableView.utils";

export function usePrintableConfigErrorMessage() {
  const t = useT();
  return (error: PrintableConfigError): string => {
    switch (error.type) {
      case "no_dashboards":
        return t("page.alert.pdf.config.error.no_dashboards");
      case "dashboard_not_found":
        return t("page.alert.pdf.config.error.dashboard_not_found", { code: error.code });
      case "dashboard_empty":
        return t("page.alert.pdf.config.error.dashboard_empty", { code: error.code });
      case "widget_not_found":
        return t("page.alert.pdf.config.error.widget_not_found", { code: error.widgetCode });
      case "widget_not_printable":
        return t("page.alert.pdf.config.error.widget_not_printable", {
          title: error.title,
          type: error.widgetType,
        });
      case "page_break_invalid":
        return t("page.alert.pdf.config.error.page_break_invalid");
      case "max_related_not_table":
        return t("page.alert.pdf.config.error.max_related_not_table", { code: error.widgetCode });
      case "max_related_out_of_range":
        return t("page.alert.pdf.config.error.max_related_out_of_range", {
          code: error.widgetCode,
          max: error.max,
        });
      case "table_missing_columns":
        return t("page.alert.pdf.config.error.table_missing_columns", { code: error.widgetCode });
    }
  };
}
